// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__2Nirt","left":"StickyBox_left__10C8j","right":"StickyBox_right__H03SK"};